// extracted by mini-css-extract-plugin
export default {"modalOverlay":"LE-z","modalContent":"ME-z","header":"NE-z","close":"OE-z"};